/**
 * The in-app thread for a phone number (pages/Texts): every office "Text" button goes here, never to the phone's own
 * Messages app (owner, Oct 29 2026: "make all text message buttons only open text in the app, not on my phone").
 * The key is the last ten digits, the same key services/texts uses; `body` lands in the compose box once (?body=).
 * Public pages (a customer texting the business from their own phone) keep their sms: links — those are not ours.
 */
export const threadKey = (phone: string | number | null | undefined): string => String(phone ?? '').replace(/\D/g, '').slice(-10);

export function textsPath(phone: string | number | null | undefined, body?: string | null): string {
  const key = threadKey(phone);
  return `/texts/${key}${body ? `?body=${encodeURIComponent(body)}` : ''}`;
}
